import './Language.scss';

import * as Yup from 'yup';

import { Form } from 'react-bootstrap';
import SelectQuestion from '../SelectQuestion/SelectQuestion';
import YesNoButton from '../YesNoButton/YesNoButton';
import { createLocalizedOptions } from '../../pages/root/App';
import iconWorld from '../../assets/images/ubisoft-playtest-icon-world-black.webp';
import { languages } from '../../utils/constants';
import messages from './messages';
import siteMessages from '../../pages/root/siteMessages';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

interface Props {
  values: any;
  errors: any;
  setFieldValue: any;
  updateSchema: (value: any) => void;
  isEnglishAbility?: boolean;
  hasLabel?: boolean;
}

export let languageSchema: any;

const Language = ({
  values,
  errors,
  setFieldValue,
  updateSchema,
  isEnglishAbility = true,
  hasLabel = true
}: Props) => {
  const intl = useIntl();
  const languagesOptions = createLocalizedOptions(languages, messages);

  useEffect(() => {
    const languageSchema = isEnglishAbility
      ? {
          languageId: Yup.number().positive(
            intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })
          ),
          listening: Yup.boolean().required(
            intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })
          ),
          speaking: Yup.boolean().required(
            intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })
          ),
          reading: Yup.boolean().required(
            intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })
          ),
          writing: Yup.boolean().required(
            intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })
          )
        }
      : {
          languageId: Yup.number().positive(
            intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })
          )
        };
    updateSchema(languageSchema);
  }, []);

  return (
    <div className="language">
      {isEnglishAbility && (
        <div className="header">
          <img src={iconWorld} alt="" />
          <h3>{intl.formatMessage({ ...messages.headerLanguage })}</h3>
        </div>
      )}
      <div className="content">
        <SelectQuestion
          controlId="languageId"
          label={hasLabel ? intl.formatMessage({ ...messages.languages }) : ''}
          isMulti={false}
          options={languagesOptions}
          value={values.languageId}
          error={errors.languageId}
          setFieldValue={setFieldValue}
        />
        {isEnglishAbility && (
          <>
            <Form.Label className="label-english">
              {intl.formatMessage({ ...messages.questions })}
            </Form.Label>
            <YesNoButton
              id="listening"
              name="listening"
              label={intl.formatMessage({ ...messages.listening })}
              value={values.listening}
              onChange={(value: any) => setFieldValue('listening', value)}
              error={errors.listening}
            />
            <div className="language-divider" />
            <YesNoButton
              id="speaking"
              name="speaking"
              label={intl.formatMessage({ ...messages.speaking })}
              value={values.speaking}
              onChange={(value: any) => setFieldValue('speaking', value)}
              error={errors.speaking}
            />
            <div className="language-divider" />
            <YesNoButton
              name="reading"
              label={intl.formatMessage({ ...messages.reading })}
              value={values.reading}
              onChange={(value: any) => setFieldValue('reading', value)}
              error={errors.reading}
            />
            <div className="language-divider" />
            <YesNoButton
              name="writing"
              label={intl.formatMessage({ ...messages.writing })}
              value={values.writing}
              onChange={(value: any) => setFieldValue('writing', value)}
              error={errors.writing}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default Language;
